import {
  type CircleApplyDetailApiResponse,
  type CircleApplyDetailResponse,
} from '~/features/circle-participation/types/circle-apply'
import {
  type BoothApplication,
  type EventInfo,
  type PageInfo,
  type PaymentInfo,
  type Ticket,
  type UserBoothApplication,
} from '~/features/circle-participation/utils/type'
import { del, get, patch, post } from '~/shared/http-client/api'
import { type ApiResponse } from '~/shared/http-client/exceptions/type'

// Request Type

export interface UserCircleBoothFormRequest {
  userBoothApplication: UserBoothApplication
}

export interface UserCircleBoothFormPatchRequest {
  userBoothApplication: UserBoothApplication
}

// Response Type
export interface CircleBoothFormResponse extends ApiResponse {
  data: {
    user_event_application_count: number
    event_info: EventInfo
    boothApplication: BoothApplication
  }
}

export interface UserCircleBoothFormResponse extends ApiResponse {
  data: {
    userBoothApplication: UserBoothApplication
  }
}

export interface UserCircleBoothFormDeleteResponse extends ApiResponse {
  data: {
    userBoothApplication: UserBoothApplication
  }
}

export interface CircleBoothInfoResponse extends ApiResponse {
  data: {
    info: {
      event_id: number
      event_date: string
      event_time: string
      enter_time: string
      apply_info: string
      notice: string
      booth_type: string
      photo_guide: string
      costume_guide: string
      place: string
    }
  }
}

export interface CircleBoothPaidListResponse extends ApiResponse {
  data: {
    payment_info: PaymentInfo
    ticket_list: Ticket[]
  }
}

export interface CircleBoothApplyListResponse extends ApiResponse {
  data: {
    pageInfo: PageInfo
    list: UserBoothApplication[]
  }
}

// function
export const getCircleBoothform = async (eventId: string) => {
  const response: CircleBoothFormResponse = await get(
    `/booth/application/eventApplication/${eventId}`,
  )

  return response
}

export const postCircleBoothform = async ({
  userBoothApplication,
}: UserCircleBoothFormRequest) => {
  const response: UserCircleBoothFormResponse = await post(
    `/booth/application/`,
    { userBoothApplication },
  )

  return response
}

export const patchCircleBoothform = async ({
  userBoothApplication,
}: UserCircleBoothFormPatchRequest) => {
  const response: UserCircleBoothFormResponse = await patch(
    `/booth/application/`,
    {
      userBoothApplication,
    },
  )

  return response
}

export const getCircleBoothApplyList = async (page: number) => {
  const response: CircleBoothApplyListResponse = await get(
    `/booth/application/list?row_per_page=5&page=${page}`,
  )

  return response.data
}

export const getCircleBoothApplyDetail = async (applicationId: string) => {
  const response: any = await get(`/booth/application/detail/${applicationId}`)

  return response
}

export const deleteCircleBoothApply = async (applicationId: string) => {
  const response: UserCircleBoothFormDeleteResponse = await del(
    `/booth/application/${applicationId}`,
  )

  return response
}

export const getCircleBoothInfo = async (eventId: string) => {
  const response: CircleBoothInfoResponse = await get(
    `/booth/application/info/${eventId}`,
  )

  return response
}

export const getCircleBoothPaidList = async (applicationId: string) => {
  const response: CircleBoothPaidListResponse = await get(
    `/booth/application/payment/${applicationId}`,
  )

  return response
}

export const getCircleApplyDetail = async (
  id: string,
): Promise<CircleApplyDetailResponse> => {
  const response: CircleApplyDetailApiResponse = await get(
    `/booth/application/detail/${id}`,
  )

  return response.data
}
